export default __webpack_public_path__ + "static/freetrial-flyer-thumb-a9bbaecbdd87b7b90485f336b26ddda4.png";